/**
 * ネイティブ（Capacitor）実行時の共通定数・判定。
 * 設計: .steering/20260719-capacitor-store-app/design.md §3.1
 */
import { Capacitor } from "@capacitor/core";

// Bundle ID / URL スキーム。design §1 D-1（Apple App ID と同一にする）
export const NATIVE_SCHEME = "jp.kakumon.app";
export const NATIVE_REDIRECT_URI = `${NATIVE_SCHEME}://auth/callback`;
export const NATIVE_LOGOUT_URI = `${NATIVE_SCHEME}://auth/logout`;

/** iOS/Android のネイティブシェル内で動作しているか（Web/PWA では false） */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * OAuth (Hosted UI) の redirect_uri。
 * authorize リクエストとトークン交換の両方で必ずこの関数の戻り値を使うこと
 * （値が食い違うと Cognito が invalid_grant を返す）
 */
export function getOAuthRedirectUri(): string {
  return isNative() ? NATIVE_REDIRECT_URI : window.location.origin;
}
